import { devConfig } from "./config.dev";
import { prodConfig } from "./config.prod";
import { envConfig } from "./envConfig";
import { Environment, IConfig } from "./config.types";

export const config: IConfig =
  envConfig.env === Environment.PROD ? prodConfig : devConfig;
